import { schema } from 'normalizr';

export const SYNDICATE = new schema.Entity('syndicates');
export const MEMBER_SYNDICATE = new schema.Entity('memberSyndicates', {
  syndicate: SYNDICATE
});



// WEBPACK FOOTER //
// ./src/schema/index.js